import { render, staticRenderFns } from "./ProductEvaluation.vue?vue&type=template&id=f0ad687c"
import script from "./ProductEvaluation.vue?vue&type=script&lang=js"
export * from "./ProductEvaluation.vue?vue&type=script&lang=js"
import style0 from "./ProductEvaluation.vue?vue&type=style&index=0&id=f0ad687c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports